import { createContext } from 'react';
export const inquiryHelpSearchContext = createContext<any>(null);
